import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Compass, ArrowLeft, Search, Home } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const NotFound = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="lp-fade-up" data-testid="not-found-page">
      <div className="relative overflow-hidden rounded-3xl bg-[#0f2a1a] text-white p-8 sm:p-12 text-center">
        <div className="absolute -right-16 -top-20 h-72 w-72 rounded-full bg-[#16a34a]/40 blur-3xl" />
        <div className="absolute left-1/4 -bottom-16 h-48 w-48 rounded-full bg-emerald-400/20 blur-2xl" />
        <div className="relative">
          <span className="mx-auto mb-4 h-16 w-16 rounded-2xl bg-white/10 flex items-center justify-center backdrop-blur"><Compass size={30} className="text-[#f5b942]" /></span>
          <p className="text-6xl sm:text-7xl font-extrabold tracking-tight">404</p>
          <h1 className="mt-2 text-2xl sm:text-3xl font-extrabold">{t("nf.thisPageTookA")}</h1>
          <p className="mt-2 text-sm text-emerald-100/80 max-w-md mx-auto">{t("nf.thePageYouRe")}</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center gap-2 bg-white text-[#0f2a1a] font-bold px-6 py-3 rounded-xl hover:bg-white/90 transition-colors"><Home size={18} /> {t("nf.backHome")}</Link>
            <Link to="/browse" className="inline-flex items-center gap-2 border border-white/25 text-white font-semibold px-5 py-3 rounded-xl hover:bg-white/10 transition-colors"><Search size={17} /> {t("nf.browseDeals")}</Link>
            <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-white/80 font-semibold px-3 py-3 hover:text-white transition-colors"><ArrowLeft size={17} /> {t("nf.goBack")}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
